import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer
} from 'recharts';

function CloudWatchChart() {
  const [metricsData, setMetricsData] = useState({});

  const fetchData = () => {
    axios.get('/api/cloudwatch-metrics/')
      .then(res => setMetricsData(res.data))
      .catch(err => console.error('CloudWatch 数据加载失败', err));
  };

  useEffect(() => {
    fetchData(); // 首次加载

    const intervalId = setInterval(() => {
      fetchData(); // 每30秒自动刷新
    }, 30000);

    return () => clearInterval(intervalId); // 组件卸载时清除定时器
  }, []);

  return (
    <div style={{ marginTop: '40px' }}>
      <h2 style={{
        fontSize: '28px',
        fontWeight: 600,
        textAlign: 'center',
        marginBottom: '24px',
        fontFamily: 'Inter, Helvetica, Arial, sans-serif',
        color: '#222'
      }}>
        📊 AWS CloudWatch real-time monitoring metrics (automatically updated every 30 seconds)
      </h2>

      <div
        className="dashboard-grid"
        style={{
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: '24px',
          padding: '0 24px'
        }}
      >
        {Object.entries(metricsData).map(([metricName, data]) => (
          <div
            key={metricName}
            className="chart-card"
            style={{
              height: '450px',           // ✔️ 和 Loss Charts 一致固定高度
              padding: '16px',           // ✔️ 和视频块一致
              border: '1px solid #ddd',  // ✔️ 有可见浅灰边框
              boxSizing: 'border-box',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              borderRadius: '8px',
              background: 'white',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
            }}
          >
            <h3 style={{
              fontWeight: 600,
              fontSize: '16px',
              textAlign: 'center',
              marginBottom: '8px',
              fontFamily: 'Inter, Helvetica, Arial, sans-serif'
            }}>
              {metricName}
            </h3>
            <ResponsiveContainer width="100%" height="85%">
              <LineChart data={data}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis
                  dataKey="timestamp"
                  tickFormatter={(str) => new Date(str).toLocaleTimeString()}
                  minTickGap={30}
                />
                <YAxis />
                <Tooltip />
                <Legend />
                <Line
                  type="monotone"
                  dataKey="value"
                  stroke="#2b6cb0"
                  strokeWidth={2}
                  dot={false}
                  name={metricName}
                />
              </LineChart>
            </ResponsiveContainer>
          </div>
        ))}
      </div>
    </div>
  );
}

export default CloudWatchChart;
